export const SLIDE_DURATION_MS = 5000

export const SLIDE_TYPE = {
  image: 'image',
  video: 'video',
}

export const isVideoSlide = type => {
  return type === SLIDE_TYPE.video
}



// WEBPACK FOOTER //
// ./src/templates/components/base/stories/const.js